import {
  Autocomplete, Box, Button, Chip, Dialog, FormControlLabel, IconButton, Radio, RadioGroup, setRef, Skeleton, Table,
  TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, Checkbox
} from '@mui/material'
import React, { useEffect, useState, useMemo } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';
import { ADD, AXIS_OPTIONS, BASE_OPTION, BCDVA_OPTIONS, BCNVA, COMMON_STYLE, CYL_OPTIONS, DEFAULT_LENS_TYPE, LENS_TYPE_OPTIONS, NV_OPTIONS, OPTICAL_CRM_API_MODE, PRISM_OPTIONS, SPH_OPTIONS, UMA_LENS, UMA_LENS_ENHANCEMENT, UMA_LENS_MATERIAL, UMA_LENS_TYPE, UMA_RECOMMENDED_EYE_WEAR } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { localGetItem, localSetItem } from '../../../../Utility/Services/CacheProviderService';
import { sha256 } from 'js-sha256';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

const createEyeTypeMap = (glassprespData = []) => {
  return glassprespData.reduce((acc, item) => {
    if (item.eye_type) acc[item.eye_type] = item;
    return acc;
  }, {});
};

const renderTableHeaders = () => (
  <TableHead>
    <TableRow>
      <TableCell className='doc_notes_tbl_header' rowSpan={2} align='center' sx={{ borderBottom: '1px solid lightgray !important' }}></TableCell>
      <TableCell className='doc_notes_tbl_header' colSpan={4} align='center' sx={{ borderBottom: '1px solid lightgray !important', borderRight: '1px solid lightgray !important' }}>Right Eye</TableCell>
      <TableCell className='doc_notes_tbl_header' colSpan={4} align='center' sx={{ borderBottom: '1px solid lightgray !important' }}>Left Eye</TableCell>
    </TableRow>
    <TableRow>
      {['SPH', 'CYL', 'AXIS', 'VA', 'SPH', 'CYL', 'AXIS', 'VA']?.map((label, idx) => (
        <TableCell key={idx} className="doc_notes_tbl_header"
          sx={{
            borderBottom: '1px solid lightgray !important',
            ...(idx === 3 && { borderRight: '1px solid lightgray !important' })
          }}>
          {label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead >
);

const UmaGlassPrescription = React.forwardRef((props, ref) => {
  const [glass, setGlass] = useState({
    patient_details: {},
    clinic_id: '',
    appointment_id: '',
    patient_id: '',
    selectedRadio: '',
    glassprespData: [],
    SPHList: SPH_OPTIONS,
    CYLList: CYL_OPTIONS,
    NVLIST: NV_OPTIONS,
    AXISList: AXIS_OPTIONS,
    ADDList: ADD,
    BCDVAList: BCDVA_OPTIONS,
    BCNVAList: BCNVA,
    PRISMList: PRISM_OPTIONS,
    BASEList: BASE_OPTION,
    eyeWearList: UMA_RECOMMENDED_EYE_WEAR,
    selectedEyeWear: '',
    lensMaterialList: UMA_LENS_MATERIAL,
    selectedLensMaterial: '',
    lensEnhancementList: UMA_LENS_ENHANCEMENT,
    selectedLensEnhacement: '',
    contactLensList: [],
    selectedContactLens: '',
    glassPrespComments: '',
    lensTypeList: UMA_LENS_TYPE,
    selectedLensType: [],
    CRMCustomer: [],
    loadScreen: false,
    subjectiveRefData: [],
    sameGlass: false,
    selectedLens: '',
    lensList: UMA_LENS,
    printLoad: false,

    // Prev
    prev_glassprespData: [],
    prev_selectedLensType: '',
    prev_selectedEyeWear: '',
    prev_selectedLensMaterial: '',
    prev_selectedLens: '',
    prev_glassPrespComments: '',
    prev_sameGlass: false,
    prev_selectedLensEnhacement: '',

    // Duplicate
    dup_glassprespData: '[]',
    dup_selectedLensType: '[]',
    dup_selectedEyeWear: '',
    dup_selectedLensMaterial: '',
    dup_selectedLens: '',
    dup_glassPrespComments: '',
    dup_sameGlass: false,
    dup_selectedLensEnhacement: '',

    // OPTICAL CRM STATES
    CRMCustomer: [],

    openComparePopup: false,
    enableCompare: false,
    enableCopy: false
  })
  const [inputValues, setInputValues] = useState({})
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })
  const userLoginData = JSON.parse(localGetItem("loggedInUserInfo"))

  useEffect(() => {
    if (glass.printLoad) {
      getGlassPrescriptionPrint()
    }
  }, [glass.printLoad, glass.selectedRadio])

  useEffect(() => {
    if (glass.glassprespData && glass.prev_glassprespData) {
      // let copy = glass.prev_glassprespData?.length > 0 ? glass.prev_glassprespData?.some((item) => (item?.DV_SPH !== '' || item?.DV_UCVA !== '' || item?.DV_CYL ||
      //   item?.DV_AXIS !== '' || item?.DV_VISION !== '' || item?.DV_BCDVA !== '' || item?.DV_BCNVA !== '' || item?.DV_PRISM !== '' || item?.DV_BASE !== '' || item?.add !== '')) : false
      // let compare = glass.glassprespData?.length > 0 ? glass.glassprespData?.some((item) => (item?.DV_SPH !== '' || item?.DV_UCVA !== '' || item?.DV_CYL ||
      //   item?.DV_AXIS !== '' || item?.DV_VISION !== '' || item?.DV_BCDVA !== '' || item?.DV_BCNVA !== '' || item?.DV_PRISM !== '' || item?.DV_BASE !== '' || item?.add !== '')) : false
      let copy = glass.prev_glassprespData?.length > 0 ? glass.prev_glassprespData?.some((item) => (item?.DV_SPH !== '' || item?.DV_CYL || item?.DV_AXIS !== '' || item?.DV_BCDVA !== ''
        || item?.NV_SPH !== '' || item?.NV_CYL !== '' || item?.NV_AXIS !== '' || item?.NV_BCNVA !== '')) : false
      let compare = glass.glassprespData?.length > 0 ? glass.glassprespData?.some((item) => (item?.DV_SPH !== '' || item?.DV_CYL || item?.DV_AXIS !== '' || item?.DV_BCDVA !== ''
        || item?.NV_SPH !== '' || item?.NV_CYL !== '' || item?.NV_AXIS !== '' || item?.NV_BCNVA !== '')) : false
      setGlass((prev) => ({
        ...prev,
        enableCompare: compare,
        enableCopy: copy
      }))
    }
  }, [glass.glassprespData, glass.prev_glassprespData])

  useEffect(() => {
    if (glass.selectedRadio === 'copy' && props.props.subjRefraData) {
      let updatedData = props.props.subjRefraData?.map((obj, index) => {
        let newObj = {};
        Object.keys(obj).forEach(key => {
          const value = obj[key];
          if ((key === 'eye_type' || key === 'SPH' || key === 'CYL' || key === 'AXIS' || key === 'BCDVA' || key === 'BCNVA')) {
            if (key === 'eye_type') {
              newObj[key] = value
              newObj['id'] = glass.glassprespData?.[index]?.id || null
            }else if(key === 'SPH'){
              newObj[`DV_${key}`] = value;
              const sph = parseFloat(obj["SPH"]);
              const add = parseFloat(obj["add"]);
              let result = (sph + add).toFixed(2);
              // Add "+" sign manually if result is positive
              if (parseFloat(result) > 0) {
                result = "+" + result;
              }
              newObj[`NV_${key}`] =  result === "0.00" ? "0" : result
            } else {
              newObj[`DV_${key}`] = value;
              newObj[`NV_${key}`] = value;
            }
          }
        });
        return newObj;
      });
      if (updatedData?.length > 0) {
        setGlass((prev) => ({
          ...prev,
          glassprespData: updatedData
        }))
      } else {
        errorMessage('No Data to Copy')
      }
    }
  }, [glass.selectedRadio, props.props.subjRefraData])

  React.useImperativeHandle(ref, () => ({
    performGlassPrescriptionAction: () => {
      // Commented autosave - saving only via manual Save button
      // if (
      //   (JSON.stringify(glass.glassprespData) !== glass.dup_glassprespData) ||
      //   (JSON.stringify(glass.selectedEyeWear) !== glass.dup_selectedEyeWear) ||
      //   (JSON.stringify(glass.selectedLensType) !== glass.dup_selectedLensType) ||
      //   (JSON.stringify(glass.selectedLensMaterial) !== glass.dup_selectedLensMaterial) ||
      //   (JSON.stringify(glass.selectedLensEnhacement) !== glass.dup_selectedLensEnhacement) ||
      //   (JSON.stringify(glass.glassPrespComments) !== glass.dup_glassPrespComments)
      // ) {
      //   postGlassPrescriptionData()
      // }
    }
  }))

  const apicalls = async () => {
    await getGlassPrescriptionData()
    await getGlassPrescriptionSuggData()

    if (props.props.isOPT) {
      await getOpticalCRMData()
      await getPrevGlassPrescriptionData()
    }
  }

  const glassprespMap = useMemo(
    () => createEyeTypeMap(glass?.glassprespData),
    [glass?.glassprespData]
  );

  const prevGlassPrespMap = useMemo(
    () => createEyeTypeMap(glass?.prev_glassprespData),
    [glass?.prev_glassprespData]
  );

  const getGlassPrescriptionData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let glassRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let newArray = [
          // {
          //   "eye_type": "RE", "DV_UCVA": "", "DV_CYL": "", "DV_AXIS": "", "DV_VISION": "",
          //   "DV_BCDVA": "", "DV_BCNVA": "", "DV_PRISM": "", "DV_BASE": "", "add": "",'DV_SPH':""
          // },
          // {
          //   "eye_type": "LE", "DV_UCVA": "", "DV_CYL": "", "DV_AXIS": "", "DV_VISION": "",
          //   "DV_BCDVA": "", "DV_BCNVA": "", "DV_PRISM": "", "DV_BASE": "", "add": "",'DV_SPH':""
          // },
          {
            "eye_type": "RE", 'DV_SPH': "", 'DV_CYL': "", 'DV_AXIS': "", 'DV_BCDVA': "",
            'NV_SPH': "", 'NV_CYL': "", 'NV_AXIS': "", 'NV_BCNVA': "",
          },
          {
            "eye_type": "LE", 'DV_SPH': "", 'DV_CYL': "", 'DV_AXIS': "", 'DV_BCDVA': "",
            'NV_SPH': "", 'NV_CYL': "", 'NV_AXIS': "", 'NV_BCNVA': "",
          },
        ]
        setGlass((prev) => ({
          ...prev,
          glassprespData: Object.keys(glassRef)?.length > 0 ? glassRef?.prescription : newArray,
          selectedLensType: Object.keys(glassRef)?.length > 0 ? (glassRef?.lens_type || []) : [],
          selectedEyeWear: Object.keys(glassRef)?.length > 0 ? glassRef?.recommended_eye_wear : '',
          selectedLensMaterial: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_material : '',
          selectedLens: Object.keys(glassRef)?.length > 0 ? glassRef?.continue_with_same_lense : '',
          selectedLensEnhacement: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_enhancement : '',
          glassPrespComments: Object.keys(glassRef)?.length > 0 ? glassRef?.comment : '',
          sameGlass: Object.keys(glassRef)?.length > 0 ? glassRef?.same_glass : false,

          dup_glassprespData: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.prescription) : JSON.stringify(newArray),
          dup_selectedLensType: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.lens_type) : '[]',
          dup_selectedEyeWear: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.recommended_eye_wear) : JSON.stringify(''),
          dup_selectedLensMaterial: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.lens_material) : JSON.stringify(''),
          dup_selectedLens: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.continue_with_same_lense) : JSON.stringify(''),
          dup_glassPrespComments: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.comment) : JSON.stringify(''),
          dup_sameGlass: Object.keys(glassRef)?.length > 0 ? glassRef?.same_glass : false,
          dup_selectedLensEnhacement: Object.keys(glassRef)?.length > 0 ? JSON.stringify(glassRef?.lens_enhancement) : JSON.stringify(''),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }
  const getGlassPrescriptionPrint = async () => {
    try {
      const response = await RestAPIService.getAllPrint(Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION +
        '?appointment_id=' + props?.props?.appointment_id + '&export_type=pdf' + '&doctor_id=' + props?.props?.doctorID
      )
      if (response) {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setGlass((prev) => ({ ...prev, printLoad: false }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
      setGlass((prev) => ({ ...prev, printLoad: false }))
    }
  }

  const getPrevGlassPrescriptionData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION_COPY +
        '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let glassRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setGlass((prev) => ({
          ...prev,
          prev_glassprespData: Object.keys(glassRef)?.length > 0 ? glassRef?.prescription : [],
          prev_selectedLensType: Object.keys(glassRef)?.length > 0 ? (glassRef?.lens_type || []) : '[]',
          prev_selectedEyeWear: Object.keys(glassRef)?.length > 0 ? glassRef?.recommended_eye_wear : '',
          prev_selectedLensMaterial: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_material : '',
          prev_selectedLens: Object.keys(glassRef)?.length > 0 ? glassRef?.continue_with_same_lense : '',
          prev_glassPrespComments: Object.keys(glassRef)?.length > 0 ? glassRef?.comment : '',
          prev_selectedLensEnhacement: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_enhancement : '',
          prev_sameGlass: Object.keys(glassRef)?.length > 0 ? glassRef?.same_glass : false,
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  function mergeUnique(arr1, arr2, key) {
    return Array.from(
      new Map([...arr1, ...arr2].map(obj => [obj[key], obj])).values()
    );
  }

  const getGlassPrescriptionSuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION_SUGG  + '?doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        let lens_type = []; let recommended_eye_wear = []; let lens_material = []; let lens_enhancement = [];
        response?.data?.lens_type?.forEach((item) => { lens_type?.push({ label: item, value: item, default: false }) })
        response?.data?.recommended_eye_wear?.forEach((item) => { recommended_eye_wear?.push({ label: item, value: item, default: false }) })
        response?.data?.lens_material?.forEach((item) => { lens_material?.push({ label: item, value: item, default: false }) })
        response?.data?.lens_enhancement?.forEach((item) => { lens_enhancement?.push({ label: item, value: item, default: false }) })

        setGlass((prev) => ({
          ...prev,
          eyeWearList: mergeUnique(glass.eyeWearList, recommended_eye_wear, 'label'),
          // lensTypeList: mergeUnique(glass.lensTypeList, lens_type, 'label'),
          lensMaterialList: mergeUnique(glass.lensMaterialList, lens_material, 'label'),
          lensEnhancementList: mergeUnique(glass.lensEnhancementList, lens_enhancement, 'label')
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postGlassPrescriptionData = async () => {
    try {
      let data = {
        appointment_id: props.props.appointment_id,
        lens_type: glass.selectedLensType,
        recommended_eye_wear: glass.selectedEyeWear,
        lens_material: glass.selectedLensMaterial,
        lens_enhancement: glass.selectedLensEnhacement,
        comment: glass.glassPrespComments,
        continue_with_same_lense: glass.selectedLens,
        same_glass: glass.selectedLens ? true : false,
        prescription: glass.glassprespData
      }

      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION)
      if (response?.data?.status === 'success') {
        await getGlassPrescriptionData()
        successMessage(response?.data?.message)
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteGlassPrescriptionSugg = async (item, key) => {
    try {
      let query = key === 'lens_type' ? `?lens_type=${item}&recommended_eye_wear=&lens_material=&lens_enhancement=` :
        key === 'selectedEyeWear' ? `?lens_type=&recommended_eye_wear=${item}&lens_material=&lens_enhancement=` :
          key === 'selectedLensMaterial' ? `?lens_type=&recommended_eye_wear=&lens_material=${item}&lens_enhancement=` :
            `?lens_type=&recommended_eye_wear=&lens_material=&lens_enhancement=${item}`
      let data = {}
      const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION_SUGG + query, data)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getGlassPrescriptionSuggData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  // OPTICAL CRM API STARTS

  const getOpticalCRMData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.OPTICAL_CRM_CUSTOMER_DETAIL)
      if (response?.data?.status && response?.data?.data) {
        if (response?.data?.status === "success") {
          setGlass((prev) => ({
            ...prev,
            opticalHouseBtn: true,
            CRMCustomer: response?.data?.data ? response?.data?.data : []
          }))
          localSetItem("OPTICAL_CRM_API_TOKEN", sha256(response.data.data?.customer_number + response.data.data?.api_key))
        }
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const opticalCRMTransfer = async () => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.OPTICAL_CRM_PATIENT_DETAIL +
        `?patient_id=${props.props.patient_id}&uhid=${props.props.patient_details?.patient_account_number}`
      )
      if (response.data.status === "success") {
        postOptCRMData(response.data.data.crm_patient_id)
      } else {
        var patient_info_OpticalCRM = {
          "mode": OPTICAL_CRM_API_MODE,
          "customerNumber": glass.CRMCustomer?.customer_number,
          "branchID": glass.CRMCustomer?.branch_id,
          "customerTitle": "",
          "fullName": props.props?.patient_details?.first_name,
          "referralCode": "",
          "membershipID": props.props?.patient_details?.patient_account_number,
          "mobileNumber": props.props?.patient_details?.mobile_number,
          "mobileNumber1": "",
          "mobileNumber2": "",
          "mobileNumber3": "",
          "mobileNumber4": "",
          "email": "",
          "taxIdentificationNumber": "",
          "customerCategory": "",
          "gender": props.props?.patient_details?.gender == "m" ? "m" : "f",
          "insuranceSchemeName": "",
          "insuranceSchemeNumber": "",
          "customerGSTNumber": "",
          "companyName": "",
          "line1": "",
          "line2": "",
          "locality": "",
          "country": "",
          "state": "",
          "city": "",
          "pincode": "",
          "dateOfBirth": props.props?.patient_details?.dob ? moment(props.props?.patient_details?.dob, 'YYYY-MM-DD').format("DD-MM-YYYY") : moment(props.props?.patient_details?.approx_dob, 'YYYY-MM-DD').format("DD-MM-YYYY"),
          "dateOfAnniversary": "",
          "customerAge": parseInt(props.props?.patient_details?.patient_age),
          "notes": ""
        }
        const CRMCusAdd = await RestAPIService.OPTICAL_CRM_POST_WITH_URL(Serviceurls.OPTICAL_CRM_CUSTOMER_ADD, patient_info_OpticalCRM)
        if (CRMCusAdd.data.status === "Success") {
          let patientInfo = {
            "emedhub_patient_id": props.props?.patient_details?.patient_id,
            "crm_patient_id": CRMCusAdd.data.data.cID,
          }
          const EmedCusAdd = await RestAPIService.create(patientInfo, Serviceurls.OPTICAL_CRM_PATIENT_DETAIL)
          if (EmedCusAdd.data.status === "success") {
            postOptCRMData(CRMCusAdd.data.data.cID)
          }
          else {
            errorMessage("something went wrong");
          }
        } else if (CRMCusAdd?.data?.error_message) {
          errorMessage(CRMCusAdd.data.error_message);
        }
        else {
          errorMessage("something went wrong");
        }
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const lensetypesforCRM = (lenseType) => {
    if (lenseType.length > 0) {
      var str = "";
      for (var i = 0; i < lenseType.length; i++) {
        str += lenseType[i].value + ", ";
      }
      return str;
    }
  }

  const transformEyeData = (data) => {
    return data.reduce((acc, item) => {
      const eyeKey = item.eye_type;
      acc[eyeKey] = {
        DV_UCVA: item.DV_UCVA,
        DV_CYL: item.DV_CYL,
        DV_AXIS: item.DV_AXIS,
        DV_VISION: item.DV_VISION,
        DV_BCDVA: item.DV_BCDVA,
        DV_BCNVA: item.DV_BCNVA,
        DV_PRISM: item.DV_PRISM,
        DV_BASE: item.DV_BASE,
        DV_SPH:item.DV_SPH,
        add: item.add,
      };
      return acc;
    }, {});
  }

  const postOptCRMData = async (cusID = null) => {
    try {
      let glassPrespData = transformEyeData(glass.glassprespData)
      var prescription_data = {
        "mode": OPTICAL_CRM_API_MODE,
        "customerNumber": glass.CRMCustomer?.customer_number,
        "branchID": glass.CRMCustomer?.branch_id,
        "cID": cusID,
        "prescriptionDate": moment(new Date()).format("DD-MM-YYYY"),
        "prescriptionType": "Eyewear",
        "patientTitle": props.props?.patient_details?.title ? props.props?.patient_details?.title : "",
        "patientName": props.props?.patient_details?.first_name,
        "doctorTitle": props.props.loginUserInfo?.doctor_title ? props.props.loginUserInfo?.doctor_title : '',
        "doctorName": props.props.loginUserInfo?.doctor_name ? props.props.loginUserInfo?.doctor_name : '',
        "doctorRegistrationNumber": props.props.loginUserInfo?.registeration_number ? props.props.loginUserInfo?.registeration_number : '',
        "doctorSpecialization": props.props.loginUserInfo?.specialization_name ? props.props.loginUserInfo?.specialization_name : '',
        "doctorMobileNumber": props.props.loginUserInfo?.mobile_number ? props.props.loginUserInfo?.mobile_number : '',
        "doctorEmail": props.props.loginUserInfo?.email ? props.props.loginUserInfo?.email : '',
        "rightSPH": glassPrespData?.RE?.DV_SPH,
        "rightCYL": glassPrespData?.RE?.DV_CYL,
        "rightAxis": glassPrespData?.RE?.DV_AXIS,
        "rightPD": "-",
        "rightVA": glassPrespData?.RE?.DV_BCDVA,
        "rightNear": "",
        "rightADD": glassPrespData?.RE?.add,
        "rightPRISM": glassPrespData?.RE?.DV_PRISM,
        "leftSPH": glassPrespData?.LE?.DV_SPH,
        "leftCYL": glassPrespData?.LE?.DV_CYL,
        "leftAxis": glassPrespData?.LE?.DV_AXIS,
        "leftPD": "-",
        "leftVA": glassPrespData?.LE?.DV_BCDVA,
        "leftNear": "",
        "leftADD": glassPrespData?.LE?.add,
        "leftPRISM": glassPrespData?.LE?.DV_PRISM,
        "lensType": lensetypesforCRM(glass.selectedLensType),
        "lensCoating": "NIL",
        "leftIOP": "",
        "rightIOP": "",
        "dominantEye": "Right,Left",
        "prescriptionNotes": "Wearing Instruction:" + '' + ". Comment:" + glass.glassPrespComments,
        "refractiveCorrection": "",
        "complains": "",
        "symptoms": "",
        "diagnosis": "",
        "prescribedMedication": "",
        "treatment": "",
        "medicalHistory": ""
      }
      if (glass.selectedLens?.length > 0) {
        try {
          const response = await RestAPIService.OPTICAL_CRM_POST_WITH_URL(Serviceurls.OPTICAL_CRM_PRESCRIPTION_POST, prescription_data)
          if (response.data.status === "Success") {
            setGlass((prev) => ({ ...prev, opticalHouseBtn: false }))
            successMessage('Transfer to Optical House Successfully')
          } else if (response?.data?.error_message) {
            errorMessage(response.data.error_message);
          } else {
            errorMessage("something went wrong");
          }
        } catch (e) {
          this.errorMessage(e.message);
        }
      } else {
        errorMessage("Please select atleast one lense type");
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - GLASS PRESCRIPTION`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - GLASS PRESCRIPTION`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

const autocompleteTextBox = (eye, field, value, options = [], optionLabel, placeholder) => {
  try {
    const fieldKey = `${eye}_${field}`;

    const handleStrictMatch = (inputValue) => {
      const matched = options.find(opt => {
        const text = typeof opt === 'string' ? opt : opt[optionLabel];
        return text?.toLowerCase() === inputValue?.toLowerCase();
      });

      const finalValue = matched ? matched[optionLabel] : "";

      setGlass(prev => ({
        ...prev,
        glassprespData: prev.glassprespData.map(item =>
          item.eye_type === eye
            ? { ...item, [field]: finalValue }
            : item
        )
      }));

      setInputValues(prev => ({
        ...prev,
        [fieldKey]: finalValue
      }));
    };

    return (
      <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked || (!props?.props?.isOPT && !userLoginData?.opto_glass_prescription_enable)}
        clearIcon
        size='small'
        sx={{ width: '8dvw' }}
          // value={values}
        options={options}
        value={options.find(o => o.label === value) || null}
        inputValue={inputValues[fieldKey] ?? value ?? ""}
        getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel]}
        onChange={(e, newValue) => {
          if (!newValue || typeof newValue === 'string') return;
          const finalValue = newValue[optionLabel];

          setGlass(prev => ({
            ...prev,
            glassprespData: prev.glassprespData.map(item =>
              item.eye_type === eye
                ? { ...item, [field]: finalValue }
                : item
            )
          }));

          setInputValues(prev => ({
            ...prev,
            [fieldKey]: finalValue
          }));
        }}

        onInputChange={(e, newInput) => {
          setInputValues(prev => ({
            ...prev,
            [fieldKey]: newInput
          }));
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            onBlur={(e) => handleStrictMatch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleStrictMatch(e.target.value);
              }
            }}
            InputProps={{
                ...params.InputProps, emed_tid: { field },
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
            }}
          />
        )}
      />
    );
  } catch (error) {
    errorMessage(error.message);
  }
};


  const autocompleteTextBox2 = (names, values, options, placeholders) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          freeSolo
          clearIcon
          size='small'
          sx={{ width: '20dvw', mr: '0.5rem' }}
          value={values}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
          onChange={(e, newValue) => {
            setGlass((prev) => ({ ...prev, [names]: newValue?.label || '' }))
          }}
          onInputChange={(e, newValue) => {
            setGlass((prev) => ({ ...prev, [names]: newValue || '' }))
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={placeholders}
              inputProps={{ ...params.inputProps, maxLength: 100 }}
              InputProps={{
                ...params.InputProps, emed_tid: { names },
                // style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
          renderOption={(props, item) => {
            return (
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                <Box component="li" {...props} width={'100%'}>
                  <Typography>{item?.label}</Typography>
                </Box>
                {names === 'selectedLens' ? null :
                  item?.default ? null : <Button className='Common_Btn_Min_Width'
                    onClick={() => { deleteGlassPrescriptionSugg(item?.label, names) }}
                  ><DeleteIcon color='error' /></Button>}
              </Box>
            )
          }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderComparePopup = () => {
  const getPrevEye = (type) => prevGlassPrespMap[type] || {};

  const prevRightEye = getPrevEye('RE');
  const prevLeftEye = getPrevEye('LE');
    try {
      return (
        <Dialog open={glass.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Glass Prescription</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setGlass((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Glass Prescription</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setGlass((prev) => ({
                        ...prev,
                        glassprespData: glass.prev_glassprespData,
                        glassPrespComments: glass.prev_glassPrespComments,
                        openComparePopup: false
                      }))
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                {/* <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PRISM</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BASE</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {glass.prev_glassprespData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.add}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BCDVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BCNVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_PRISM}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BASE}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table> */}
                <Table size="small">
                  {renderTableHeaders()}
                  <TableBody>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>DV</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.DV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.DV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.DV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{prevRightEye.DV_BCDVA || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.DV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.DV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.DV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.DV_BCDVA || '-'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>NV</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.NV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.NV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevRightEye.NV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{prevRightEye.NV_BCNVA || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.NV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.NV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.NV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{prevLeftEye.NV_BCNVA || '-'}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Glass Prescription</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                {/* <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PRISM</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BASE</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {glass.glassprespData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.add}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BCDVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BCNVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_PRISM}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.DV_BASE}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table> */}
                <Table size="small">
                  {renderTableHeaders()}
                  <TableBody>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>DV</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.DV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.DV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.DV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{rightEye.DV_BCDVA || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.DV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.DV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.DV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.DV_BCDVA || '-'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>NV</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.NV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.NV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{rightEye.NV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{rightEye.NV_BCNVA || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.NV_SPH || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.NV_CYL || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.NV_AXIS || '-'}</TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>{leftEye.NV_BCNVA || '-'}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const isChecked = (item) =>
    glass.selectedLensType.some((selected) => selected.value === item.value);

  const handleCheckboxChange = (item) => (event) => {
    if (event.target.checked) {
      setGlass((prev) => ({
        ...prev,
        // Multi select check functionality
        // selectedLensType: [...prev.selectedLensType, item]
        selectedLensType: [item]
      }))
    } else {
      setGlass((prev) => ({
        ...prev,
        // Multi select uncheck functionality
        // selectedLensType: prev?.selectedLensType?.filter(
        //   (selected) => selected.value !== item.value
        // ),
        selectedLensType: [],
      }));
    }
  };

  console.log(glass.glassprespData,'GLASSPRESP')

  const getEye = (type) => glassprespMap[type] || {};

  const rightEye = getEye('RE');
  const leftEye = getEye('LE');

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font' mr={'1rem'}>Glass Prescription</Typography>
              {(props?.props?.isOPT || userLoginData?.opto_glass_prescription_enable) ?
                <RadioGroup emed_tid={'ref_radio'}
                  row
                  value={glass.selectedRadio}
                  onClick={(e) => {
                    if(glass.selectedRadio === 'copy' && props?.props?.subjRefraData?.length === 0){
                      setGlass((prev) => ({ ...prev, selectedRadio: '' }))
                    }else{
                      setGlass((prev) => ({ ...prev, selectedRadio: e.target.value }))
                    }
                  }}
                >
                  <FormControlLabel value="copy" control={<Radio size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} />} label={<Typography className='doc_notes_header_card_font'>Copy from Subjective Refraction</Typography>} />
                </RadioGroup> : null}
            </Box>
            {(props?.props?.isOPT || userLoginData?.opto_glass_prescription_enable) ?
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Tooltip placement='top' arrow title={'Save'}><IconButton className='Common_Btn_Min_Width' emed_tid='ref_save'
                  disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={() => postGlassPrescriptionData()}
                ><SaveIcon color='primary' /></IconButton></Tooltip>
                <Tooltip placement='top' arrow title={'Print'}><IconButton className='Common_Btn_Min_Width' emed_tid='ref_prt'
                  onClick={() => setGlass((prev) => ({ ...prev, printLoad: true }))}
                ><PrintIcon color='primary' /></IconButton></Tooltip>
                <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='ref_cpy'
                  disabled={!glass.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={() => setGlass((prev) => ({
                    ...prev,
                    glassprespData: glass.prev_glassprespData
                  }))}
                ><ContentCopyIcon color={!glass.enableCopy ? '' : 'primary'} /></IconButton></Tooltip>
                <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='ref_vis'
                  disabled={!(glass.enableCopy && glass.enableCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={() => setGlass((prev) => ({ ...prev, openComparePopup: true }))}
                ><VisibilityIcon color={!(glass.enableCopy && glass.enableCompare) ? '' : 'primary'} /></IconButton></Tooltip>
              </Box> : null}
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              {/* <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                    <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                    <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                    <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                    <TableCell className='doc_notes_tbl_header'>PRISM</TableCell>
                    <TableCell className='doc_notes_tbl_header'>BASE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {glass?.glassprespData?.length > 0 ? glass?.glassprespData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_SPH', item?.DV_SPH, glass?.SPHList, 'label', 'SPH', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_CYL', item?.DV_CYL, glass?.CYLList, 'label', 'CYL', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_AXIS', item?.DV_AXIS, glass?.AXISList, 'label', 'AXIS', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('add', item?.add, glass?.ADDList, 'label', 'ADD', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_BCDVA', item?.DV_BCDVA, glass?.BCDVAList, 'label', 'BCDVA', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_BCNVA', item?.DV_BCNVA, glass?.BCNVAList, 'label', 'BCNVA', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_PRISM', item?.DV_PRISM, glass?.PRISMList, 'label', 'PRISM', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('DV_BASE', item?.DV_BASE, glass?.BASEList, 'label', 'BASE', index)}
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={9}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table> */}
              <Table size="small">
                {renderTableHeaders()}
                <TableBody>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>DV</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'DV_SPH', rightEye.DV_SPH, glass?.SPHList, 'label', 'SPH')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'DV_CYL', rightEye.DV_CYL, glass?.CYLList, 'label', 'CYL')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'DV_AXIS', rightEye.DV_AXIS, glass?.AXISList, 'label', 'AXIS')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{autocompleteTextBox('RE', 'DV_BCDVA', rightEye.DV_BCDVA, glass?.BCDVAList, 'label', 'VA',)}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'DV_SPH', leftEye.DV_SPH, glass?.SPHList, 'label', 'SPH')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'DV_CYL', leftEye.DV_CYL, glass?.CYLList, 'label', 'CYL')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'DV_AXIS', leftEye.DV_AXIS, glass?.AXISList, 'label', 'AXIS')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'DV_BCDVA', leftEye.DV_BCDVA, glass?.BCDVAList, 'label', 'VA',)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_body_cell' sx={{fontWeight: 600}} align='center'>NV</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'NV_SPH', rightEye.NV_SPH, glass?.NVLIST, 'label', 'SPH')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'NV_CYL', rightEye.NV_CYL, glass?.CYLList, 'label', 'CYL')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('RE', 'NV_AXIS', rightEye.NV_AXIS, glass?.AXISList, 'label', 'AXIS')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{autocompleteTextBox('RE', 'NV_BCNVA', rightEye.NV_BCNVA, glass?.BCNVAList, 'label', 'VA')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'NV_SPH', leftEye.NV_SPH, glass?.NVLIST, 'label', 'SPH')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'NV_CYL', leftEye.NV_CYL, glass?.CYLList, 'label', 'CYL')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'NV_AXIS', leftEye.NV_AXIS, glass?.AXISList, 'label', 'AXIS')}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBox('LE', 'NV_BCNVA', leftEye.NV_BCNVA, glass?.BCNVAList, 'label', 'VA')}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
            {(props?.props?.isOPT || userLoginData?.opto_glass_prescription_enable) ?
              <><Box component={'div'} display={'flex'} m={'1rem 0rem'}>
                {autocompleteTextBox2('selectedEyeWear', glass.selectedEyeWear, glass?.eyeWearList, 'Recommended Eye Wear')}
                {/* <Autocomplete
                  clearIcon
                  size='small'
                  multiple
                  sx={{ width: '20vw', mr: '0.5rem' }}
                  options={glass.lensTypeList}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                  value={glass.selectedLensType}
                  limitTags={1}
                  autoComplete='off'
                  onChange={(event, newValue) => {
                    setGlass((prev) => ({ ...prev, selectedLensType: newValue }))
                  }}
                  renderInput={(params) => <TextField {...params} label='Lens Type' />}
                  renderOption={(props, item) => {
                    return (
                      <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                        <Box component="li" {...props} width={'100%'}>
                          <Typography>{item?.label}</Typography>
                        </Box>
                        {item?.default ? null : <Button className='Common_Btn_Min_Width'
                          onClick={() => { deleteGlassPrescriptionSugg(item?.label, 'lens_type') }}
                        ><DeleteIcon color='error' /></Button>}
                      </Box>
                    )
                  }}
                /> */}
                {autocompleteTextBox2('selectedLensMaterial', glass.selectedLensMaterial, glass?.lensMaterialList, 'Lens Material')}
                {autocompleteTextBox2('selectedLensEnhacement', glass.selectedLensEnhacement, glass?.lensEnhancementList, 'Lens Enhancement')}
              </Box>
                <Typography className='doc_notes_header_card_font'>Lens Type</Typography>
                <Box display="flex" flexDirection="row" gap={2}>
                  {glass?.lensTypeList?.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={
                        <Checkbox
                          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                          size='small'
                          emed_tid={`ref_lens_type_${item.value}`}
                          checked={isChecked(item)}
                          onChange={handleCheckboxChange(item)}
                        />
                      }
                      label={item.label}
                    />
                  ))}
                </Box>
              </> : null}
            <Box component={'div'} display={'flex'} alignItems={'center'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked || (!props?.props?.isOPT && !userLoginData?.opto_glass_prescription_enable)}
                size='small'
                multiline
                rows={3}
                maxRows={5}
                sx={{ width: '39.2dvw', mr: '0.5rem' }}
                label='Comments'
                value={glass.glassPrespComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= 500) {
                    setGlass((prev) => ({ ...prev, glassPrespComments: value }))
                  }
                }}
                inputProps={{ emed_tid: 'ref_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
              {/* {props?.props?.isOPT ?
                <Box component={'div'}>
                  <Typography fontWeight={600} fontSize={'0.9rem'}>Continue with same contact lens</Typography>
                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    {autocompleteTextBox2('selectedLens', glass.selectedLens, glass?.lensList, 'Select Lens')}
                    <Button variant='contained' sx={{ textTransform: 'capitalize', width: '19.5dvw' }} emed_tid='tfr_optl_hse'
                      disabled={props.props.isLocked || props.props.patient_transfered || (glass.selectedLens === '')}
                      onClick={() => opticalCRMTransfer()}
                    >Transfer To Optical House</Button>
                  </Box>
                </Box> : null} */}
            </Box>
          </Box>
        </Box>
        {renderComparePopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaGlassPrescription